
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contenidos/[slug]",
      function () {
        return require("private-next-pages/contenidos/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contenidos/[slug]"])
      });
    }
  